module.exports = __webpack_public_path__ + "static/media/Best-Sustainability-Initiative-Fintech-Award-2023.d6aa9aa7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Best-Sustainability-Initiative-Fintech-Award-2023.webp
// module id = 132
// module chunks = 0